export const APP_DOWNLOAD_POSTER_KEY = 'appDownloadPoster';

export interface AppDownloadPosterValue {
  buyerAppPosterUrl: string;
  sellerAppPosterUrl: string;
  wechatDouyinPosterUrl: string;
}

export const emptyAppDownloadPoster = (): AppDownloadPosterValue => ({
  buyerAppPosterUrl: '',
  sellerAppPosterUrl: '',
  wechatDouyinPosterUrl: '',
});

export const parseAppDownloadPoster = (raw: string | undefined): AppDownloadPosterValue => {
  if (!raw?.trim()) {
    return emptyAppDownloadPoster();
  }
  try {
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    return {
      buyerAppPosterUrl: typeof parsed.buyerAppPosterUrl === 'string' ? parsed.buyerAppPosterUrl : '',
      sellerAppPosterUrl:
        typeof parsed.sellerAppPosterUrl === 'string' ? parsed.sellerAppPosterUrl : '',
      wechatDouyinPosterUrl:
        typeof parsed.wechatDouyinPosterUrl === 'string' ? parsed.wechatDouyinPosterUrl : '',
    };
  } catch {
    return emptyAppDownloadPoster();
  }
};

export const readAppDownloadPoster = (configs: Map<string, string>): AppDownloadPosterValue => {
  const parsed = parseAppDownloadPoster(configs.get(APP_DOWNLOAD_POSTER_KEY));
  return {
    buyerAppPosterUrl: parsed.buyerAppPosterUrl.trim(),
    sellerAppPosterUrl: parsed.sellerAppPosterUrl.trim(),
    wechatDouyinPosterUrl: parsed.wechatDouyinPosterUrl.trim(),
  };
};
